import React from 'react';
import { Row, Col, Input, Card, Button, Media, CardBody } from 'reactstrap';
import { useMicroReception } from '../../../hooks/microsanitaryReception/useMicroReception';
import { ModalSampleMicro } from './ModalSampleMicro';
import { SamplesTable } from './SamplesTable';
import { ConfigServer } from '../../../data/config';




export const IndexSampleReception = () => {
    const {
        checkNim,
        handleInputChangeNim,
        formNim,
        showDetails,
        samples,
        handleCloseViewSend,
        isModalOpen,
        selectedSample,
        handleOpenModal,
        handleCloseModal,
        thermometers,
        containers,
        handleChangeMic,
        saveMicDetailSend,
        reasons,
        status,
        units,
        _nim,
        navigateQuoter,
        characteristic,
        handleOpenModalAuthorization,
        handleCloseModalAuthorization,
        isModalAuthorization,
        password,
        setPassword,
        saveValidate,
        invalidPasword,
        messageInvalid,
        dataSamplings,
        loadingSample,
        loadingMic


    } = useMicroReception();

    const { nim } = formNim;

    return (
        <div className='container-global-zoom'>


            <Col lg="12" className="d-none d-md-block pl-0 pt-2">
                <Card className="company-banner-card">
                    <CardBody>
                        <div className="company-banner-content">

                            <div className="company-banner-selectors">
                                <label className='text-white f-16 f-w-700' >Cliente:</label>
                                <label className='text-white f-16 f-w-700' > {dataSamplings.nameClient ?? ""}  </label>
                            </div>

                            <div
                                className={`company-banner-info `}
                            >
                                <>

                                    <div className="company-item">
                                        <i className="fa fa-file-text-o" />
                                        <div>
                                            <span>Código de de la cotización</span>
                                            <strong>{dataSamplings.quoter ?? "------"}</strong>
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <i className="fa fa-credit-card" />
                                        <div>
                                            <span>Nim</span>
                                            <strong>{dataSamplings.codeNim ?? "------"}</strong>
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <i className="fa fa-phone" />
                                        <div>
                                            <span>Telefono</span>
                                            <strong>{dataSamplings.phone ?? "------"}</strong>
                                        </div>
                                    </div>
                                    <div className="company-item company-email">
                                        <i className="fa fa-envelope" />
                                        <div>
                                            <span>Correo</span>
                                            <strong>{dataSamplings.email ?? "------"}</strong>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>

            <Col sm="12" className="quoter-ios" >
                <Row>
                    <Col sm="3">
                        <Card className={`helen-card `}>
                            <CardBody>
                                <div className="section-header">
                                    <i className="icofont icofont-bars"></i>
                                    <span>Recepción de Muestras</span>
                                </div>

                                <div className="sampling-check-reception">
                                    {
                                        showDetails && <label style={{ color: "#64748b", fontSize: "14px" }}>
                                            Este nim es el que se encuentra actualmente capturando.
                                        </label>

                                    }
                                    {
                                        !showDetails && <label style={{ color: "#64748b", fontSize: "14px" }}>
                                            Ingresa manualmente las <b>muestras</b>.
                                        </label>

                                    }
                                    <br /><br />

                                    <Col sm="12" className="pl-0 pr-0">
                                        <Input
                                            className="text-center form-control form-control-sm input-air-primary"
                                            name="nim"
                                            value={nim}
                                            onChange={handleInputChangeNim}
                                            disabled={loadingSample || showDetails}
                                        />
                                    </Col>

                                    <br />

                                    {
                                        showDetails && <div className="d-flex justify-content-center">
                                            <button
                                                className="modalButton"
                                                onClick={() => _nim === undefined ? handleCloseViewSend() : navigateQuoter()}
                                                style={{ backgroundColor: "#1f4e69" }}
                                                disabled={loadingSample}
                                            >
                                                Regresar
                                            </button>


                                        </div>
                                    }

                                    {
                                        !showDetails && <div className="d-flex justify-content-center">
                                            <button
                                                className="modalButton"
                                                onClick={checkNim}
                                                style={{ backgroundColor: "#1f4e69" }}
                                                disabled={loadingSample}
                                            >
                                                Ingresar
                                            </button>
                                        </div>
                                    }
                                </div>

                                {loadingSample && (
                                    <div className="sampling-loading">
                                        <div className="sampling-loading-dot"></div>
                                        <div className="sampling-loading-dot"></div>
                                        <div className="sampling-loading-dot"></div>
                                    </div>
                                )}

                            </CardBody>
                        </Card>
                    </Col>

                    <Col sm="9" >
                        <Card className={`helen-card determination-card`}>
                            <CardBody>
                                <div className="matrix-header">
                                    <div className="matrix-icon">
                                        <i className="icofont icofont-tablets"></i>
                                    </div>

                                    <div className="matrix-title">
                                        MUESTRAS Y DETERMINACIONES
                                        <small>
                                            Captura las muestras , para el proceso de la recepción.
                                        </small>
                                    </div>
                                </div>
                                {
                                    !showDetails && <div className="empty-determinations">

                                        <div className="floating-circle circle-1"></div>
                                        <div className="floating-circle circle-2"></div>
                                        <div className="floating-circle circle-3"></div>
                                        <div className="floating-circle circle-4"></div>
                                        <div className="floating-circle circle-5"></div>

                                        <div className="empty-content">
                                            <i className="fa fa-flask"></i>
                                            <h6>Sin muestras</h6>
                                            <small>Coloque un nim para comenzar el proceso.</small>
                                        </div>

                                    </div>
                                }


                                {
                                    showDetails && <div>
                                        <SamplesTable
                                            samples={samples}
                                            onEditSample={handleOpenModal}
                                            handleOpenModalAuthorization={handleOpenModalAuthorization}
                                            handleCloseModalAuthorization={handleCloseModalAuthorization}
                                            isModalAuthorization={isModalAuthorization}
                                            selected={selectedSample}
                                            password={password}
                                            setPassword={setPassword}
                                            saveValidate={saveValidate}
                                            invalidPasword={invalidPasword}
                                            messageInvalid={messageInvalid}
                                        />
                                        <ModalSampleMicro
                                            isOpen={isModalOpen}
                                            toggle={handleCloseModal}
                                            sample={selectedSample}
                                            samples={samples}
                                            thermometers={dataSamplings.thermometers}
                                            containers={dataSamplings.containers}
                                            reasons={dataSamplings.reasons}
                                            status={dataSamplings.status}
                                            handleChangeMic={handleChangeMic}
                                            saveMicDetailSend={saveMicDetailSend}
                                            units={dataSamplings.units}
                                            characteristic={dataSamplings.characteristic}
                                            loadingMic={loadingMic}
                                        />

                                    </div>
                                }
                            </CardBody>
                        </Card>
                        <Card>
                        </Card>
                    </Col>
                </Row>
            </Col >
        </div >
    );
};